function sleeper(ms) {
  return new Promise((resolve) => setTimeout(() => resolve(), ms));
}

export default sleeper;
